import {
  parseTrailingCountByClause,
  splitFacetedSearchTokens,
} from "@/components/faceted-search/facetedSearchSyntax";

// Read-only parser for the retired inline `COUNT BY` clause. Saved dashboards and shared URLs still
// carry it; `legacyCountByToState` lifts what this returns into an aggregation.
export interface CountByClause {
  facets: string[];
  limit?: number;
}

export interface ParsedCountByQuery {
  // The query with the trailing COUNT BY clause removed (send this as the backend filter).
  filterQuery: string;
  clause: CountByClause | null;
}

export const parseCountByQuery = (query: string): ParsedCountByQuery => {
  const tokens = splitFacetedSearchTokens(query);
  const parsed = parseTrailingCountByClause(tokens);
  if (parsed == null) {
    return { filterQuery: query, clause: null };
  }
  // Strip the clause even when incomplete (no facet) so it never leaks into the backend filter as
  // free text.
  const filterQuery = tokens.slice(0, parsed.keywordIndex).join(" ");
  return { filterQuery, clause: parsed.clause.facets.length === 0 ? null : parsed.clause };
};
